import React from 'react';
import { Modal } from '@landr/maestro';

type SplitModalProps = {
    children: React.ReactNode;
    isOpen: boolean;
    onClose: () => void;
};

const SplitModal: React.FC<SplitModalProps> = ({
    children,
    isOpen,
    onClose,
}) => {
    return (
        <Modal
            theme="light"
            isOpen={isOpen}
            onClose={onClose}
            size="lg"
            borderRadius="modal"
            border="none"
        >
            <Modal.Content borderRadius="modal">
                <Modal.Section padding="none" display="flex">
                    {children}
                </Modal.Section>
            </Modal.Content>
        </Modal>
    );
};

export default SplitModal;
